import React from 'react';
import { Button } from '@mui/material';

interface XboxLoginButtonProps {
  onLoginSuccess: (user: any) => void;
  redirectPath: string;
}

const XboxLoginButton: React.FC<XboxLoginButtonProps> = ({ onLoginSuccess, redirectPath }) => {
  const handleXboxLogin = () => {
    const xboxAuthUrl = `https://login.microsoftonline.com/${process.env.REACT_APP_XBOX_TENANT_ID || 'common'}/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_XBOX_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(
      `${process.env.REACT_APP_FRONTEND_URL}/auth/xbox/callback?mode=login`
    )}&scope=openid%20profile%20User.Read&response_mode=query`;
    
    window.location.href = xboxAuthUrl;
  };

  return (
    <Button
      variant="outlined"
      onClick={handleXboxLogin}
      startIcon={
        <img 
          src="/icons/service/xbox.svg" 
          alt="Xbox" 
          style={{ width: '20px', height: '20px', filter: 'invert(1)' }}
        />
      }
      fullWidth
              sx={{
          mt: 2,
          borderColor: 'rgba(255, 255, 255, 0.12)',
          color: 'text.primary',
          background: 'linear-gradient(135deg, rgba(16, 124, 16, 0.1), rgba(85, 139, 85, 0.1))',
          '&:hover': {
            borderColor: 'rgba(255, 255, 255, 0.2)',
            background: 'linear-gradient(135deg, rgba(16, 124, 16, 0.15), rgba(85, 139, 85, 0.15))'
          },
          textTransform: 'none',
          fontWeight: 500,
          py: 0.75,
          backdropFilter: 'blur(8px)',
          transition: 'all 0.2s ease',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(16, 124, 16, 0.4), rgba(85, 139, 85, 0.4))',
            zIndex: -1
          }
        }}
    >
      Xboxでログイン
    </Button>
  );
};

export default XboxLoginButton; 